import React from 'react'
import './devanimation.css'

function DevAnimation() {
  return (

    <div className='skcont'>
        <div className='skname'>
            <span>frontend</span>
            <span>backend</span>
            <span>blockchain</span>
        </div>
        <p className='dvlpr' >DEVELOPER</p>
    </div>

  )
}

export default DevAnimation
